import { GenericSchedule, PickupScheduleDetailResponse } from "./upplm.pickupdetails";
import { SelectedDays } from "./upplm.placardInformation";

export class PickupDetailsEditSession {
    pickupType: string;
    saturdayToogle: boolean;
    allSchedule: GenericSchedule[];
    selectedDays: SelectedDays[];
    pickupScheduleDetailResponse: PickupScheduleDetailResponse;
    pickupComesFromLocation: boolean;
}